module.exports = __webpack_public_path__ + "assets/img/50@3x.a9ee938f.png";